


























































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ElHeader: () => import('./parts/header.vue'),
    ElSidebar: () => import('./parts/sidebar.vue'),
    ElMobileFooter: () => import('./parts/mobile-footer.vue'),
  },
})
export default class Empty extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: false }) readonly hasSidebar!: boolean;

  @Prop({ default: false }) readonly scrollable!: boolean;

  @Prop({ default: false }) readonly slideoutOpen!: boolean;

  @Prop({ default: 'container' }) readonly containerClass!: string;

  @Prop({ default: '600px' }) readonly sliderWidth!: boolean;

  @Prop({ default: '' }) readonly contentClass!: string;
}
